<template>
  <a-card class="m-t-10" :bordered='false'>
    <a-button size='small' @click="()=>{$router.go(-1)}">
      <LeftOutlined />返回 </a-button>
    <span class="ml15 card_title">统计详情</span>
  </a-card>
  <a-card :bordered="false">
    <div class="m-b-20 s_flex_ali">
      <div class="p-r-15 width-140">
        <a-button :type="active == 1 ? 'primary':''" block @click='tabClick(1)'>每日数量统计</a-button>
      </div>
      <div class="p-r-15 width-140">
        <a-button :type="active == 2 ? 'primary':''" block @click='tabClick(2)'>渠道统计</a-button>
      </div>
      <div class="p-r-15 width-140">
        <a-button :type="active == 3 ? 'primary':''" block @click='tabClick(3)'>地域统计</a-button>
      </div>
    </div>
    <a-form ref='form' :model='search' :style="{'marginBottom':'20px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="日期" name='time'>
        <rangeDisabledDate  @ontimechange='onChange' v-model:value='time' :rangedata='time' type='first' format='YYYY-MM-DD'></rangeDisabledDate>
        <span class="s_c999">（最大查询日期区间为30天）</span>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
    </a-form>
    <a-spin :spinning="listLoading">
      <div class="p-t-30" v-if='!listLoading && active == 1'>
        <echartLine :echartsData='echartData' v-if='!listLoading'></echartLine>
      </div>
      <tables :listLoading='listLoading' :data='data' :keyRow='keyRow' :active='active' v-if='!listLoading'></tables>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"  @showSizeChange="pageSizeChange" v-if='active !== 2' :show-total="total => `总数: ${total} `" />
    </a-spin>
  </a-card>
</template>
<script>
import { ref, onMounted,reactive, toRefs,inject } from "vue";
import { message } from "ant-design-vue";
import { couponDaysStatistics, couponStoreStatistics, couponChannelStatistics} from "@/api/assets";
import { iscode } from "@/utils/app";
import tables from './components/table'
import { LeftOutlined } from '@ant-design/icons-vue';

// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 10,
  start_time:'',
  end_time:''
};
export default {
  components: { tables, LeftOutlined},
  setup(props) {
    const search = ref({ ...defSearch });
    const state = reactive({
      active:1,
      data:[],
      listLoading:false,
      total: 0,
      keyRow:'',
      time:[],
      echartData: {
        dataName:['发放数量','使用数量'],
        latelyDays:[],
        series:[]
      },
    });
    const $route = inject('$route')
    //tab切换
    const tabClick = (index) =>{
      state.active = index;
      state.time = [];
      search.value = { ...search.value, page: 1,limit: 10,start_time:'',end_time:'' };
      initData();
    }
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData();
    };
    // 分页当前页切换
    const pageCurrentChange = (page) => {
      search.value.page = page;
      initData();
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData();
    };
    // 时间筛选
    const onChange = (e) => {
      search.value.start_time = e[0]
      search.value.end_time = e[1]
    }
    //每日统计
    const getDay = async() =>{
      state.listLoading = true;
      let res = await couponDaysStatistics({...search.value,coupon_id:$route.query.id}).then(res=>res.data);
      if (iscode(res)) {
        state.data = res.data.data;
        state.total = res.data.total;
        var latelyDays = []
        var receive_num = []
        var use_num = []
        res.data.graph.map(v => {
          latelyDays.push(v.date_time)
          receive_num.push(v.receive_num)
          use_num.push(v.use_num)
        })
        state.echartData.latelyDays =latelyDays
        state.echartData.series = [
          {
            name: '发放数量',
            data:receive_num,
            type: 'line',
            symbolSize: 6,
            smooth: true
          },
          {
            name: '使用数量',
            data: use_num,
            type: 'line',
            symbolSize: 6,
            smooth: true
          },
        ]
      } else {
        message.error(res.msg);
      }
      state.listLoading = false;
    } 
    //渠道统计
    const getCannel = async() =>{
      state.listLoading = true;
      let res = await couponChannelStatistics({...search.value,coupon_id:$route.query.id}).then(res=>res.data);
      if (iscode(res)) {
        state.data = res.data;
      } else {
        message.error(res.msg);
      }
      state.listLoading = false;
    }
    //区域统计
    const getRegion = async() =>{
      state.listLoading = true;
      let res = await couponStoreStatistics({...search.value,coupon_id:$route.query.id}).then(res=>res.data);
      if (iscode(res)) {
        state.data = res.data.data;
        state.total = res.data.total;
      } else {
        message.error(res.msg);
      }
      state.listLoading = false;
    }
    const initData = () =>{
      if(state.active == 1){
        state.keyRow = 'date_time'
        getDay()
      }else if(state.active == 2){
        state.keyRow = 'source_type_text'
        getCannel()
      }else{
        state.keyRow = 'store_name'
        getRegion()
      }
    }
    onMounted(() => {
      initData()
    });
    return {
      ...toRefs(state),
      search,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      onChange,
      tabClick
    };
  },
};
</script>